import { SymbolSpineUtil } from './SymbolSpineUtil'

export const symbolUtil = new SymbolSpineUtil()
